import classnames from 'classnames';
import React, { forwardRef, Ref } from 'react';

import { IconTypes } from '@eika/icon';

import Button from '../Button';
import { BasicButtonProps } from '../Props';

export interface ActionButtonProps extends BasicButtonProps {
    icon: IconTypes;
    /**
     * changes the background color of the button
     * @default false
     */
    isSecondary?: boolean;
}

const ActionButton = forwardRef(
    (
        { children, className, isSecondary = false, ...rest }: ActionButtonProps,
        ref: Ref<HTMLButtonElement>,
    ): React.JSX.Element => (
        <Button
            buttonType="action"
            className={classnames('action-button__button', className, {
                'action-button__button--secondary': isSecondary,
            })}
            {...rest}
            ref={ref}
        >
            {children}
        </Button>
    ),
);

export default ActionButton;
